import React, { useEffect } from 'react';

import { track, useAutoNavigate } from '@betterment/js-runtime';
import { Button, H3, Text, VStack } from '@betterment/samba-react';

import { trackClick } from '../../features/track';
import { urlBuilder } from '../../Shared/urlBuilder';

export const ProfileSetupContent: React.FC = () => {
  const navigate = useAutoNavigate();

  useEffect(() => {
    track('ElementViewed', {
      name: 'ProfileSetupPrompt',
      module: 'AccountRecommendation',
    });
  }, []);

  return (
    <VStack css={{ gap: 'space.300', alignItems: 'flex-start' }}>
      <H3 variant="title300" color="text">
        Get a recommended account
      </H3>
      <Text variant="text100" color="text">
        Finish creating your financial profile so we can recommend the accounts that make the most sense for your
        financial situation.
      </Text>
      <Button
        variant="solidPrimary"
        onClick={() => {
          trackClick({
            name: 'CreateFinancialProfile',
            module: 'AccountRecommendation',
          });
          void navigate(urlBuilder.appProfileSetupFlow.absolute());
        }}
      >
        Create financial profile
      </Button>
    </VStack>
  );
};
